export default __webpack_public_path__ + "static/media/logo-symbol-white.5ba1ef3d.svg";